import "./App.css";
import Swap from "./Swap";
import { usePrivy } from "@privy-io/react-auth";

function App() {
  const { ready } = usePrivy();
  
  if (!ready) {
    return (
      <div className="App flex items-center justify-center min-h-screen bg-black text-white">
        Loading...
      </div>
    );
  }
  
  return (
    <div className="App">
      <Swap />
    </div>
  );
}

export default App;
